<template>
    <div :class="['see_pop_right_mask', 'animated', showAnimated ? 'findinMask' : 'findOutMask']" v-show="seePopRightOkShow">
        <div :class="['see_pop_right', 'animated', showAnimated ? 'fadeInRightBig' : 'fadeOutRightBig']">
            <div class="see_title">
               <span>选择设备</span>
            </div>

            <pop-device @closePopDevice="closePopDevice">
            </pop-device>

            <span @click="boxClose" 
            style="position: absolute; top: 0;left:0;padding:10px;color:#FF4949">
            <i class="el-icon-close Danger"></i></span>
        </div>
    </div>
</template>
<script>
    import popDevice from '@/page/adMgr/popDevice'
    export default {
      props: ['seePopRightOk'],
      data () {
        return {
          showAnimated: true
        }
      },
      computed: {
        seePopRightOkShow: function () {
          this.showAnimated = true
          return this.seePopRightOk
        }
      },
      methods: {
        boxClose () {
          this.showAnimated = false
          var _this = this
          setTimeout(function () {
            _this.$emit('closeSeeRightPop', '')
          }, 500)
        },
        closePopDevice (val) {
          this.showAnimated = false
          var _this = this
          setTimeout(function () {
            _this.$emit('closeSeeRightPop', val)
          }, 500)
        }
      },
      components: {
        'pop-device': popDevice
      }
    }
</script>
<style lang="scss">
  .see_pop_right_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 1000;
  }
  .see_pop_right {
    top: 0;
    right: 0;
    left: 10%;
    bottom: 0;
    z-index: 1001;
    position: fixed;
    background: #eef1f6;

    .see_title {
        background: white; 
        padding: 10px;
        border-bottom: 1px solid #ccc;

        p {
            margin:0;
            padding: 5px;
            color: black;
            font-size: 20px;
            font-weight: 500;
        }
        span {
            margin-right: 5px;
        }
    }
  }

  .animated {
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }

    .animated.infinite {
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }

    .animated.hinge {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
    }

    @-webkit-keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }

    @keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }
    }

    .fadeInRightBig {
      -webkit-animation-name: fadeInRightBig;
      animation-name: fadeInRightBig;
    }

    @-webkit-keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
    .findinMask {
      -webkit-animation-name: findinMask;
      animation-name: findinMask;
    }



    @-webkit-keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    @keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    .fadeOutRightBig {
      -webkit-animation-name: fadeOutRightBig;
      animation-name: fadeOutRightBig;
    }

    @-webkit-keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
    .findOutMask {
      -webkit-animation-duration: 0.5s;
      animation-duration: 0.5s;
      -webkit-animation-name: findOutMask;
      animation-name: findOutMask;
    }
</style> 


// WEBPACK FOOTER //
// src/page/adMgr/puPopRight.vue